<template>
<div class="qrcodeMask" v-show='showQrcode'>
  <div id="qrcode" style="display:none"></div>
  <div class="closeBtn" @click="closeQrcode"><i class="el-icon-circle-close" /></div>
  <div class="imgMask">
    <ul>
      <li v-for="(item,index) in qrcodeDatas" :key="index">
        <div class="qrcodeMess">
          <div class="title">消防巡检</div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="zoneName">{{item.pointName}}</div>
        </div>
        <div class="qrcodeImg">
          <!-- <img :src="'data:image/png;base64,' +item.qrEntity.body " alt=""> -->   
          <vue-qr :logo-src="logoSrc"
          :size="191"
          :margin="0"
          :auto-color="true"
          :dot-scale="1"
          :text="item.pointId+';'+item.pointName" />
        </div>
      </li>
    </ul>    
    <div class="print" @click="print()">
      <img src="../../assets/img/print.png" alt="">
    </div>  
  </div>
</div>
</template>

<script>
var base64 = require("js-base64").Base64;
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
export default {
  components:{
    vueQr
  },
  props: {
    showQrcode: {
      type: Boolean,
      default: true
    },
    qrcodeDatas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      logoSrc:require("../../assets/img/fire1.png"),
    }
  },
  created() {
    console.log(this.qrcodeDatas)
    // this.init()
  },
  methods: {
    init() {
      
    },
    closeQrcode() {
      this.$emit('closeQrcode', false)
    },
    print() {
      window.print();
      return
      // alert('添加打印事件')
    },
  }
}
</script>

<style lang="scss" scoped>
.qrcodeMask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1999;
  padding: 40px;

  .closeBtn {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 50px;
    color: #fff;
    cursor: pointer;
    z-index: 2000;
  }

  .imgMask {
    width: 95%;
    height: 92%;
    position: absolute;
    box-sizing: border-box;
    padding: 20px;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%,-50%);
    background: #fff;

    .print {
      background: #1C95D4;
      border-radius: 50%;
      width: 64px;
      height: 64px;
      padding: 10px;
      position: absolute;
      right: 10%;
      top: 100px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }

    ul {
      overflow: hidden;
      width: 1130px;

      li {
        float: left;
        overflow: hidden;
        // width: 350px;
        // height: 230px;
        width: 254px;
        height: 161px;
        border: 5px solid #244EA1;
        // border-right: none;
        margin: 0 20px 20px 0;

        .qrcodeMess {
          width: 100px;
          float: left;
          box-sizing: border-box;
          padding: 10px;
          margin-top: 10px;

          .title {
            width: 81px;
            margin: 0 auto;
            font-size: 28px;
            font-weight: 600;
            letter-spacing: 10px;
            // border: 1px solid red;
            padding-left: 5px;
            padding-bottom: 8px;
          }

          .zoneName {
            text-align: center;
            color: #6e6e6e;
            font-weight: 400;
            font-size: 14px;
            margin-top: 8px;
          }

          .line {
            width: 100%;
            height: 1px;
            background: #35A942;
            margin-bottom: 4px;
          }
        }

        .qrcodeImg {
          margin-top: 11px;
          margin-right: 10px;
          float: right;
          width: 140px;
          height: 140px;
          box-sizing: border-box;
          border: 4px solid #1C95D4;
          padding: 8px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style><style lang="scss">
@media print {

  .leftSide,
  .topSide,
  .tavBox,
  .mainContent,
  .el-drawer_wrapper {
    display: none;
  }

  .qrcodeMask {
    background: rgba(0, 0, 0, 0);
  }

  .closeBtn,
  .print {
    display: none;
  }
}
</style>
